import type { Step4PredictResponse } from "@/chargeDetection/types"
import { CHARGE_CATEGORY_COLORS, CHARGE_CATEGORY_DESCRIPTIONS, CHARGE_CATEGORY_LABELS } from "@/chargeDetection/types"
import Speedometer from "@/refrigerant/Speedometer"
import { Card } from "@/components/ui/card";

export interface Step4PredictResultsProps {
  data: Step4PredictResponse
}

export function Step4PredictResults({ data }: Step4PredictResultsProps) {
  const speedometerCategories = data.all_thresholds.map(t => ({
    threshold: t.max_percent,
    color: CHARGE_CATEGORY_COLORS[t.category]
  }))

  const categoryColor = CHARGE_CATEGORY_COLORS[data.category]

  return (
    <Card className="p-4 bg-gray-50 border-dashed space-y-4">
      <div className="flex flex-col items-center">
        <Speedometer
          value={data.charge_percent}
          center={100}
          delta={15}
          categories={speedometerCategories}
        />
        <div
          className="text-sm font-semibold text-gray-700 mt-2 underline decoration-2"
          style={{ textDecorationColor: categoryColor, textUnderlineOffset: "2px" }}
        >
          {CHARGE_CATEGORY_LABELS[data.category]}
        </div>
      </div>
      <div>
        <p className="text-sm text-gray-600">
          {CHARGE_CATEGORY_DESCRIPTIONS[data.category]}
        </p>
      </div>
    </Card>
  )
}
